import { FC } from "react";
import { Avatar } from "components/core";
import { classNames } from "utils";

interface ComplaintViewProps {
  complaint: any;
}

const ComplaintView: FC<ComplaintViewProps> = ({ complaint }) => {
  return (
    <div className='space-y-6 divide-y divide-gray-200'>
      {/* {JSON.stringify(complaint, null, 2)} */}
      <div>
        <span className='text-xs font-light'>Customer Information</span>
        <div className='grid grid-cols-3 gap-6 mt-2'>
          <div className='row-span-3 flex flex-col space-y-3 items-center justify-center'>
            <Avatar
              alt={
                complaint?.customer?.representative?.fullName ||
                complaint?.customer?.organization?.name ||
                "N A"
              }
              src={complaint?.customer?.representative?.profileImageUrl || ""}
              size='xl'
            />

            <span
              className={classNames(
                "bg-gray-100 text-gray-800",
                complaint?.customer?.status === "SuperAdmin"
                  ? `bg-gray-100 text-[#F87A17] dark:bg-[#F87A17] dark:text-gray-50`
                  : "",
                complaint?.customer?.status === "Admin"
                  ? `bg-gray-100 text-[#657383] dark:bg-[#657383] dark:text-gray-50`
                  : "",
                complaint?.customer?.status === "Supervisor"
                  ? `bg-gray-100 text-[#FF4040] dark:bg-[#FF4040] dark:text-gray-50`
                  : "",
                complaint?.customer?.status === "Reader"
                  ? `bg-gray-100 text-[#9ACD32] dark:bg-[#9ACD32] dark:text-gray-50`
                  : "",
                complaint?.customer?.status === "Queued"
                  ? `bg-gray-100 text-[#D4A017] dark:bg-[#D4A017] dark:text-gray-50`
                  : "",
                complaint?.customer?.status === "Success"
                  ? `bg-green-100 text-green-800 dark:bg-green-600 dark:text-gray-50`
                  : "",
                complaint?.customer?.status === "Reversed"
                  ? `bg-green-100 text-green-800 dark:bg-green-600 dark:text-gray-50`
                  : "",
                !complaint?.customer?.status
                  ? "bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-100"
                  : "",
                "inline-flex rounded-full  px-2 py-1 text-xs items-center space-x-1"
              )}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 10 10'
                fill='currentColor'
                className='w-1.5 h-1.5'
              >
                <circle
                  fillRule='evenodd'
                  cx='5'
                  cy='5'
                  r='5'
                  clipRule='evenodd'
                />
              </svg>
              <span>{complaint?.customer?.status || "Active Contract"}</span>
            </span>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Customer Code
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.customer?.code || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Ghana Card Number
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.customer?.complaintType === "Individual"
                ? complaint?.customer?.representative?.ghanaCardNumber || "N/A"
                : complaint?.customer?.organization
                  ?.organizationRegistrationNumber || "N/A"}
            </div>
          </div>
          <div className='col-span-2'>
            <span className='block text-sm font-light text-gray-700'>
              Full Name
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.customer?.representative?.fullName ||
                complaint?.customer?.organization?.name ||
                "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Phone Number
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.customer?.representative?.phoneNumber ||
                complaint?.customer?.organization?.phoneNumber ||
                "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Email Address
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.customer?.representative?.emailAddress ||
                complaint?.customer?.organization?.emailAddress ||
                "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div className='pt-6'>
        <span className='text-xs font-light'>Complaint Details</span>
        <div className='grid grid-cols-3 gap-6 mt-2'>
          <div>
            <span className='block text-sm font-light text-gray-700'>Code</span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.code || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>Type</span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.type?.name || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Status
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.status || "N/A"}
            </div>
          </div>
          <div className='col-span-3'>
            <span className='block text-sm font-light text-gray-700'>
              Description
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.description || "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div className='pt-6'>
        {/* {JSON.stringify(complaint?.createdBy, null, 2)} */}
        <span className='text-xs font-light'>Created By</span>
        <div className='grid grid-cols-2 gap-6 mt-2'>
          <div className='col-span-2'>
            <span className='block text-sm font-light text-gray-700'>
              Full Name
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {[
                complaint?.createdBy?.firstName,
                complaint?.createdBy?.lastName,
              ].join(" ") || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Phone Number
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.createdBy?.phoneNumber || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Email Address
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.createdBy?.emailAddress || "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div className='pt-6'>
        <span className='text-xs font-light'>Contact Person Information</span>
        <div className='grid grid-cols-2 gap-6 mt-2'>
          <div className='col-span-2'>
            <span className='block text-sm font-light text-gray-700'>
              Full Name
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.contactPerson?.fullName || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Phone Number
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.contactPerson?.phoneNumber || "N/A"}
            </div>
          </div>
          <div>
            <span className='block text-sm font-light text-gray-700'>
              Email Address
            </span>
            <div className='mt-1 block w-full sm:text-sm'>
              {complaint?.contactPerson?.emailAddress || "N/A"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintView;
